<template>
  <v-row
    justify="center"
    class="ma-n3 ma-sm-auto"
    :no-gutters="_includes(['sm', 'xs'], $mq)"
  >
    <v-col>
      <v-card
        class="home mx-auto"
        max-width="600"
        :outlined="!_includes(['sm', 'xs'], $mq)"
        :tile="_includes(['sm', 'xs'], $mq)"
        :flat="_includes(['sm', 'xs'], $mq)"
      >
        <v-img
          v-if="homeBanner"
          :src="homeBanner"
          class="white--text align-end home-banner-img"
          :gradient="
            hideBannerTitle ? null : 'to bottom, rgba(0,0,0,.0), rgba(0,0,0,.5)'
          "
        >
          <v-card-title
            class="text-center"
            v-if="!getBooleanToggle('Hide Home Banner Title')"
          >
            <h1 class="mt-4 mx-auto">{{ getShopTitle }}</h1>
            <h3 v-if="getIsBakeSale">w/ Bakers Against Racism</h3>
          </v-card-title>
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>

        <v-card-title v-else>
          <h1 class="mt-4">{{ getShopTitle }}</h1>
          <h3 v-if="getIsBakeSale">w/ Bakers Against Racism</h3>
        </v-card-title>
        <v-card-text class="pb-5 px-5">
          <v-row class="mb-4"
            ><v-col class="pt-0">
              <!-- <v-row
                ><v-col>
                  <div>
                    Fulfillment Options
                    <v-chip
                      v-for="opt of getFulfillmentOptions"
                      :key="opt"
                      label
                      class="ma-1"
                      color="gray"
                      text-color="black"
                      outlined
                      >{{ opt }}</v-chip
                    >
                  </div>
                  <div
                    >Payment Options
                    <v-chip
                      v-for="opt of getPaymentOptions"
                      :key="opt"
                      label
                      class="ma-1"
                      color="gray"
                      text-color="black"
                      outlined
                      >{{ opt }}</v-chip
                    >
                  </div>
                  <v-row v-if="getInstagram || getTwitter || getFacebook">
                    <v-col>
                      Social Links
                      <v-chip
                        v-if="getInstagram"
                        label
                        class="ma-1"
                        color="gray"
                        text-color="black"
                        outlined
                        :href="
                          `https://instagram.com/${getInstagram.replace(
                            '@',
                            ''
                          )}`
                        "
                        target="_blank"
                        >Instagram</v-chip
                      >
                      <v-chip
                        v-if="getTwitter"
                        label
                        class="ma-1"
                        color="gray"
                        text-color="black"
                        outlined
                        :href="
                          `https://twitter.com/${getTwitter.replace('@', '')}`
                        "
                        target="_blank"
                        >Twitter</v-chip
                      >
                      <v-chip
                        v-if="getFacebook"
                        label
                        class="ma-1"
                        color="gray"
                        text-color="black"
                        outlined
                        :href="getFacebook"
                        target="_blank"
                        >Facebook</v-chip
                      >
                    </v-col>
                  </v-row>
                </v-col></v-row
              > -->

              <v-btn
                v-if="!getCustomerPhoneDigits.length"
                class="mt-4 mb-2 white--text"
                color="blue"
                to="/menu"
                depressed
                :block="_includes(['sm', 'xs'], $mq)"
                x-large
                >View the Menu</v-btn
              >
              <v-btn
                v-else
                class="my-2 white--text"
                color="blue"
                :to="`/customer/${getCustomerPhoneDigits}/new`"
                depressed
                x-large
                >Place an Order</v-btn
              >
            </v-col>
          </v-row>
          <AirtableHtml setting-name="Home Page" />
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import _includes from 'lodash/includes'
import AirtableHtml from '@/components/AirtableHtml'

export default {
  name: 'HomeView',
  components: { AirtableHtml },
  data: () => {
    return {
      phone: '',
    }
  },
  computed: {
    ...mapGetters('shop', [
      'getShopDetail',
      'getBooleanToggle',
      'getShopTitle',
      'getIsBakeSale',
      'getFulfillmentOptions',
      'getPaymentOptions',
      'getInstagram',
      'getTwitter',
      'getFacebook',
    ]),
    ...mapGetters('customer', ['getCustomerPhoneDigits']),

    homeBanner() {
      let banner = this.getShopDetail('Home Banner')
      if (banner) {
        banner = JSON.parse(banner)
        if (banner.url && banner.path) {
          return banner.url.replace(
            banner.path,
            `f_auto,c_scale,w_1000/${banner.path}`
          )
        }
      }
      return banner && banner.url ? banner.url : undefined
    }, // homeBanner
    hideBannerTitle() {
      return this.getShopDetail('Hide Home Banner Title')
    }, // hideBannerTitle
  },
  created() {},
  methods: {
    _includes,
  },
}
</script>

<style lang="scss">
.home-banner-img {
  height: 50vh;
  max-height: 300px;
}
</style>
